function base64ToBlob(base64: string) {
  const [meta, content] = base64.split(",");
  const mime = meta.match(/:(.*?);/)?.[1] || "image/jpeg";
  const byteCharacters = atob(content);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  return new Blob([new Uint8Array(byteNumbers)], { type: mime });
}

export default base64ToBlob;
